<script>
  export let icon;
  export let onClick;
</script>

<div class="editBoxButtonContainer fadedButton" on:click={onClick}>
  <img src={icon} alt="Box Button" />
</div>

<style>
  div.editBoxButtonContainer {
    background-color: #d7e1ea;
    height: 343px;
    width: 118px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div.editBoxButtonContainer:not(:last-child) {
    margin-bottom: 25px;
  }

  img {
    width: 20px;
  }
</style>
